import { useState } from "react";
import { NotificationBar } from "@asosteam/asos-web-component-library-notification-bar";
import PropTypes from "prop-types";
import styles from "./styles";

const LoyaltyJoinError = ({ message }) => {
  const [isHidden, setIsHidden] = useState(false);
  return (
    <div className={styles.container}>
      {!isHidden && (
        <NotificationBar onClose={() => setIsHidden(true)} type="error">
          <span>{message}</span>
        </NotificationBar>
      )}
    </div>
  );
};

LoyaltyJoinError.propTypes = {
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

export default LoyaltyJoinError;
